import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import withState from 'recompose/withState';
import withProps from 'recompose/withProps';
import withHandlers from 'recompose/withHandlers';
import setDisplayName from 'recompose/setDisplayName';

// this HOC is for handling the case of the user refreshing the page before an auto-save
// text field's `blur` event has had a chance to fire.
//
// it provides the wrapped component with callbacks (via props) for signaling when editing
// has begun and when it has ended.
//
// the HOC will listen to `beforeunload` on window and if editing is still in progress
// when that event is fired, it will cancel that event. this causes the browser to pop up
// an alert signaling that there are unsaved changes, prompting the user to confirm before
// allowing them to navigate away or refresh the page.

export default compose(
  setDisplayName('UnsavedChangesHandler'),
  withState('hasUnsavedChanges', 'setHasUnsavedChanges', false),
  withProps(props => ({
    isEditing: () => props.setHasUnsavedChanges(true),
    doneEditing: () => props.setHasUnsavedChanges(false)
  })),
  withHandlers({
    // onBeforeunload: props => event => {
    //   if (props.hasUnsavedChanges) {
    //     // https://developer.mozilla.org/en-US/docs/Web/Events/beforeunload
    //     event.preventDefault();
    //     event.returnValue = '';
    //   }
    // }
  }),
  lifecycle({
    // componentDidMount() {
    //   window.addEventListener('beforeunload', this.props.onBeforeunload);
    // },
    // componentWillUnmount() {
    //   window.removeEventListener('beforeunload', this.props.onBeforeunload);
    // }
  })
);



// WEBPACK FOOTER //
// ./public/hoc/catchUnsavedChanges.jsx